






























































































































































































import { Component } from 'vue-mixin-decorator';

import MarkdownToHTML from '@/common/MarkdownToHTML';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import RadarChart from '@/components/RadarChart.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as StringUtil from '@/common/StringUtil';

import * as DesignCode from '@/classification/DesignCode';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import DesignResource from '@/models/exam/DesignResource';
import Rank from '@/models/rank/Rank';
import Evaluation from '@/models/evaluation/Evaluation';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-radar-chart': RadarChart,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class GuestExamResult extends BaseView {
  private examInfo: ExamInfo = new ExamInfo();

  private resultRankCode = '';

  private entryCode = '';

  private resultCode = '';

  private rank: Rank = new Rank();

  private otherRanks: Rank[] = [];

  private benefits: any[] = [];

  private result = null;

  private categories = null;

  private evaluations: Evaluation[] = [];

  private videoWidth = '100%';

  private isIndicatorDisplay = false;

  private childTab: Window | null = null;

  private resources = {
    ENTRY_ICON: new DesignResource(),
    BENEFITS_ICON: new DesignResource(),
    RANK_BENEFIT_THUMBNAIL: new DesignResource(),
    RESULT_BENEFITS_BG: new DesignResource(),
    RESULT_BENEFITS_MAIN_COLOR: new DesignResource(),
    RESULT_BENEFITS_SUB_TITLE_COLOR: new DesignResource(),
    BENEFITS_BADGE_ALL: new DesignResource(),
    BENEFITS_BADGE_PASS: new DesignResource(),
    BENEFITS_BADGE_PERFECT: new DesignResource(),
    EXAM_RANK_ICON: new DesignResource(),
    TOP_ENTRY_MAIN_COLOR: new DesignResource(),
    EXAM_RETRY_IMG: new DesignResource(),
    CHART_TITLE: new DesignResource(),
    PASS_DISPLAY_COMMENT: new DesignResource(),
    PASS_DISPLAY_IMG: new DesignResource(),
    FAIL_DISPLAY_COMMENT: new DesignResource(),
    FAIL_DISPLAY_IMG: new DesignResource(),
    GOODS_APPEAL_IMG: new DesignResource(),
    ANSWER_RATE_RESULT_BG: new DesignResource(),
    CHART_TITLE_CATEGORY_BG: new DesignResource(),
    CHART_TITLE_EVALUATION_BG: new DesignResource(),
  };

  private async mounted() {
    const { entry, result } = this.$route.query;
    if (entry === undefined || result === undefined) {
      this.$router.replace(this.paths.TOP);
    }
    this.entryCode = String(entry);
    this.resultCode = String(result);

    this.initStaticScripts();

    this.isIndicatorDisplay = true;

    // 検定情報を取得する
    const ExamRepository = RepositoryFactory.get().exam;
    await ExamRepository.getExam().then((response: any) => {
      if (response.status === 200) {
        // eslint-disable-next-line prefer-destructuring
        const data = response.data;
        this.examInfo.examTitle = data.exam_title;
        this.examInfo.inPeriod = data.in_period;
        // デザインリソース
        if (data.resources !== undefined) {
          data.resources.forEach((resource: any) => {
            const key = resource.display_place_key;
            if (key in this.resources) {
              const tmp = new DesignResource();
              tmp.displayPlaceKey = resource.display_place_key;
              tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
              tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
              tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
              tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
              tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              this.resources[key] = tmp;
            }
          });
        }
      }
    });

    // 受験結果を取得
    const EntryRepository = RepositoryFactory.get().guest;
    await EntryRepository.getGuestResult(this.entryCode, this.resultCode).then((response: any) => {
      if (response.status === 200) {
        this.result = response.data;
        if (this.result !== null) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.categories = this.result.categories;

          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.resultRankCode = this.result.exam_rank_code;

          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.result.evaluations.forEach((evaluation: any) => {
            const eva = new Evaluation();
            eva.evaluationCode = evaluation.evaluation_code;
            eva.evaluationTitle = evaluation.evaluation_title;
            eva.correctRate = evaluation.correct_rate;
            this.evaluations.push(eva);
          });
        }
      }
    }).catch(() => {
      this.$router.replace(this.paths.TOP);
    });

    // 獲得特典の取得
    await EntryRepository.getGuestBenefits(this.entryCode, this.resultCode).then((response: any) => {
      if (response.status === 200
        && response.data.benefits !== undefined) {
        this.benefits = response.data.benefits;
        this.benefits.forEach((benefit) => {
          const b = benefit;
          b.explanation = MarkdownToHTML(b.explanation);
          b.notes = MarkdownToHTML(b.notes);
        });
      }
    }).catch(() => {
      this.$router.replace(this.paths.TOP);
    });

    // 検定ランクを取得する
    const RankRepository = RepositoryFactory.get().rank;
    await RankRepository.getRanks().then((response: any) => {
      if (response.status === 200
        && response.data.exam_ranks !== undefined) {
        response.data.exam_ranks.forEach((rank: any) => {
          const rankObj = new Rank();
          rankObj.rankCode = StringUtil.encodeToBase64Url(rank.exam_rank_code);
          rankObj.title = rank.exam_rank_title;
          if (rank.fees.length > 0) {
            rankObj.fee = StringUtil.separateNumber(rank.fees[0].fee);
          } else {
            rankObj.fee = '0';
          }
          rankObj.paymentType = rank.exam_fee_type;

          // eslint-disable-next-line prefer-destructuring
          const resources = rank.resources;
          if (resources !== undefined && resources.length > 0) {
            resources.forEach((resource: any) => {
              if (resource.display_place_key === DesignCode.EXAM_RANK_ICON) {
                rankObj.thumbnail = resource.resource_uri;
                rankObj.alternativeText = resource.alternative_text;
              }
            });
          }

          // 受験したランクとその他のランクを分ける
          if (this.resultRankCode === rank.exam_rank_code) {
            this.rank = rankObj;
          } else {
            this.otherRanks.push(rankObj);
          }
        });
      }
    });

    this.isIndicatorDisplay = false;
  }

  /**
   * 検定詳細画面に遷移します。
   *
   * @param ランクコード（Base64エンコードされたコード）
   */
  private transitionExamDetail(rankCode: string) {
    this.$router.replace(`${this.paths.KENTEI_DETAIL}?rank=${rankCode}`);
  }

  /**
   * 静的CssとJsの読み込み
   */
  private initStaticScripts() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ExamResultCss = document.createElement('link');
    ExamResultCss.rel = 'stylesheet';
    ExamResultCss.href = '/exam/css/result.css';
    this.$el.appendChild(ExamResultCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 映像ファイルか判定する
   *
   * @param filename ファイル名
   */
  // eslint-disable-next-line class-methods-use-this
  private isVideo(filename: string) {
    if (filename === undefined) return false;
    const etx = GuestExamResult.getExt(filename);
    const video = ['mp4'];
    return video.includes(etx);
  }

  /**
   * 音声ファイルか判定する
   *
   * @param filename ファイル名
   */
  // eslint-disable-next-line class-methods-use-this
  private isAudio(filename: string) {
    if (filename === undefined) return false;
    const etx = GuestExamResult.getExt(filename);
    const audio = ['mp3', 'm4a'];
    return audio.includes(etx);
  }

  /**
   * 拡張子を取得する
   *
   * @param filename ファイル名
   */
  static getExt(filename: string) {
    const pos = filename.lastIndexOf('.');
    if (pos === -1) return '';
    return filename.slice(pos + 1);
  }

  /**
   * 試験画面へ遷移
   */
  private transitionToExam() {
    if (this.childTab !== null) {
      // eslint-disable-next-line no-alert
      alert('既に診断ページが表示されています');
      return;
    }
    const encodeRankCode = StringUtil.encodeToBase64Url(this.resultRankCode);
    // 新しく開いたwindowオブジェクトを保持
    this.childTab = window.open(`${this.paths.GUEST_EXAM}?entry=${this.entryCode}&rank=${encodeRankCode}`, `exam${Date.now()}`);
  }
}
